import { SEAT_ORDER } from './tableSeats';

export const ANIM_GAP_MS = 30;
export const TRICK_GATHER_MS = 780;
export const PLAY_FLY_MS = 380;
export const FLY_WATCHDOG_MS = PLAY_FLY_MS + ANIM_GAP_MS + 120;
export const GATHER_WATCHDOG_MS = TRICK_GATHER_MS + ANIM_GAP_MS + 200;
export const RECONCILE_ESCALATE_MS = 3000;

/** Card offset from table center for each visual seat (matches SpadesCenter). */
export function trickOffset(visual, trickDist) {
  const map = {
    north: { x: 0, y: -trickDist, rot: 0 },
    south: { x: 0, y: trickDist, rot: 180 },
    east: { x: trickDist, y: 0, rot: 90 },
    west: { x: -trickDist, y: 0, rot: -90 },
  };
  return map[visual] || { x: 0, y: 0, rot: 0 };
}

/** Origin toward a seat's hand for play-fly. */
export function flyOrigin(visual, handReach) {
  const map = {
    north: { x: 0, y: -handReach, rot: 0 },
    south: { x: 0, y: handReach, rot: 180 },
    east: { x: handReach, y: 0, rot: 90 },
    west: { x: -handReach, y: 0, rot: -90 },
  };
  return map[visual] || { x: 0, y: 0, rot: 0 };
}

/** Direction from center toward a seat's hand / trick-pile area. */
export function seatReachOffset(visual, reach) {
  const map = {
    north: { x: 0, y: -reach, rot: 0 },
    south: { x: 0, y: reach, rot: 180 },
    east: { x: reach, y: 0, rot: 90 },
    west: { x: -reach, y: 0, rot: -90 },
  };
  return map[visual] || { x: 0, y: 0, rot: 0 };
}

export function playId(play) {
  if (!play?.seat || !play?.card?.id) return null;
  return `${play.seat}-${play.card.id}`;
}

export function trickKey(trick) {
  return (trick || []).map((p) => `${p.seat}-${p.card?.id}`).join('|');
}

/** Server bumps trickWonCounts before resolve ends — find who gained a trick. */
export function findTrickWinnerFromCounts(serverCounts, displayedCounts) {
  for (const seat of SEAT_ORDER) {
    if ((serverCounts?.[seat] || 0) > (displayedCounts?.[seat] || 0)) {
      return seat;
    }
  }
  return null;
}

export function emptyTrickCounts() {
  return { north: 0, east: 0, south: 0, west: 0 };
}

export function countsEqual(a, b) {
  return SEAT_ORDER.every((s) => (a?.[s] || 0) === (b?.[s] || 0));
}